import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { Link } from 'gatsby';

import * as linkedin_white from '../images/linkedin_white.png';
import * as insta_white from '../images/insta_white.png';
import * as logo_white from '../images/logo_white.png';

class FootBar extends Component<{}, { mobile: boolean }> {
	private mql;
	constructor(props) {
		super(props);

		this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
	}
	componentWillMount() {
		if (typeof window !== undefined) {
			this.mql = window.matchMedia(`(min-width: 960px)`);
			this.setState({
				mobile: !this.mql.matches
			});
			this.mql.addListener(this.mediaQueryChanged);
		}
	}
	componentWillUnmount() {
		if (this.mql) {
			this.mql.removeListener(this.mediaQueryChanged);
		}
	}
	mediaQueryChanged() {
		if (this.mql.matches) {
			this.setState({ mobile: false });
		} else {
			this.setState({ mobile: true });
		}
	}
	render() {
		return (
			<div>
				<Row className='foot-menu uk-light' type='flex' justify='space-around' align='middle'>
					<Col md={6} sm={24}>
						<div
							className={`uk-flex ${this.state.mobile
								? 'uk-flex-center'
								: 'uk-flex-left'} uk-margin-small-top uk-margin-small-bottom`}
						>
							<Link to={'/'} className='navbar-item logo-title'>
								<img
									data-uk-img
									height={64}
									width={64}
									data-src={logo_white}
									alt='Logo-THAD'
									className='logo-image'
								/>
							</Link>
						</div>
					</Col>
					<Col md={12} sm={24}>
						<div className='uk-flex uk-flex-center uk-flex-wrap uk-margin-small-top uk-margin-small-bottom'>
							© 2019 All Rights Reserved
						</div>
					</Col>
					<Col md={6} sm={24}>
						<div
							className={`uk-flex ${this.state.mobile
								? 'uk-flex-center'
								: 'uk-flex-right'} uk-margin-small-top uk-margin-small-bottom uk-margin-small-right`}
						>
							<Row gutter={8} type='flex' justify='space-around' align='middle'>
								<Col span={12}>
									<a href='https://www.instagram.com/thad.ca/' target='_blank' rel='noopener'>
										<img className='footer-icon' src={insta_white} />
									</a>
								</Col>
								<Col span={12}>
									<a
										href='https://ca.linkedin.com/in/tyler-hawryluk-b362ab83'
										target='_blank'
										rel='noopener'
									>
										<img className='footer-icon' src={linkedin_white} />
									</a>
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
			</div>
		);
	}
}

export default FootBar;
